'use strict';

let _ = require('underscore');
let createStore = require('fluxible/addons/createStore');
let ActionConstants = require('../../nav/actions/ActionConstants');

let SearchStore = createStore({
    storeName: 'SearchStore',
    handlers: {
        [ActionConstants.SEARCH.SEARCH_TERM_CHANGED]       : 'onSearchTermChanged',
        [ActionConstants.SEARCH.SEARCH_RESULT_RETURNED]    : 'onSearchResultReturned'
    },
    initialize() {
        this.term = '';

        // Default to the search term, if it exists
        if (window.location.search) {
            // .substring(1) to remove the leading '?'
            _.forEach(window.location.search.substring(1).split('&'), function (pair) {
                var split = pair.split('=');
                if (split[0] === 'q') {
                    this.term = split[1].replace(/\+/g, ' ');
                }
            }, this);
        }
        this.results = [];
    },
    getTerm() {
        return this.term;
    },
    getResults() {
        return this.results;
    },
    getState() {
        return {
            term : this.term,
            results : this.results
        };
    },
    onSearchTermChanged(payload) {
        // If the term is empty, clear the results as well
        if (this.term === '') {
            this.results = [];
        }

        this.term = payload.term;
        this.emit('change');
    },
    onSearchResultReturned(payload) {
        this.results = payload.results;
        this.emit('change');
    }
});

module.exports = SearchStore;



// WEBPACK FOOTER //
// ./assets/js/global/core/nav/stores/SearchStore.es.js